<script setup lang="ts">
import { useToggle } from '@vueuse/core'
import { useAppDark } from '@/composables/useAppDark'

const isDark = useAppDark();

const toggleDark = useToggle( isDark );
</script>

<template>
  <!-- WMD-1234: promoted from <div> to <button type="button"> + aria-label.
       Original was a clickable div with no role, keyboard handler, or
       accessible name — inaccessible to keyboard users and screen readers.
       Now reachable via getByRole('button', { name: /toggle dark|light mode/i })
       which is how POMs address it (see PnfChartPage.toggleTheme). -->
  <button
    type="button"
    class="btn btn-sm btn-ghost"
    :aria-label="isDark ? 'Toggle light mode' : 'Toggle dark mode'"
    :aria-pressed="isDark"
    @click="toggleDark()"
  >
    <template v-if="isDark">
      <i class="text-primary pi pi-moon"></i>
    </template>
    <template v-else>
      <i class="text-primary pi pi-sun"></i>
    </template>
  </button>
</template>
